<!--单位管理界面-->
<template>
    <div class="unitManageBody">
        <unitManageDialog ref="unitManageDialog" />
        <!--头部按钮部分-->
        <div class="unitMangeTitle">
            <iconButton @buttonClick='addMenu' buttonText='添加同级' icoName="wedoButton/add.png"></iconButton>
			<iconButton @buttonClick='addMenuChild' buttonText='添加子级' icoName="wedoButton/add.png"></iconButton>
			<iconButton @buttonClick='editMenu' buttonText='修改' icoName="wedoButton/edit.png"></iconButton>
			<iconButton @buttonClick='deleteMenu' buttonText='删除' icoName="wedoButton/delete.png"></iconButton>
			<iconButton @buttonClick='refresh' buttonText='刷新' icoName="wedoButton/delete.png"></iconButton>
        </div>
        <div class="unitMangeContent" :style="getBackgroudImageStyle('huanbao/jpfaGuanLi/background.png')">
            <div class="unitMangeContent_box">
			<div class="unitMangeContent_header">
				<div class="unitMangeContent_header_left"></div>
				<div class="unitMangeContent_header_right">组织架构</div>
			</div>
		<!--	<div class="unitMangeContent_table">
                <hTreeTable @changeActive="changeActive" @handlerExpand="handlerExpand" :list.sync="getUnitTree" ref='hTreeTable' />
            </div>-->
            </div>
        </div>
    </div>
</template>

<script>
/*import hTreeTable from "../huanbaoyongdiang/components/hTreeTable.vue"*/
import iconButton from '@/components/module/universal/iconButton.vue'
import unitManageDialog from './unitManageDialog.vue'

export default {
    components: {
        unitManageDialog,
       /* hTreeTable,*/
        iconButton,
    },
    props: {},
    data() {
        return {
            nowMenu: undefined,
        }
    },
    created() {},
    mounted() {},
    destroyed() {},
    computed: {
        getUnitTree() {
            let tree = this.$store.unitStore.getters.getUnitTree
            if (isempty(tree)) {
                return []
            } else {
                return [tree]
            }
        },
        getResourcesByName() {
            return this.$store.resourcesStore.getters.getResourcesByName
        },
        getBackgroudImageStyle() {
            return this.$store.resourcesStore.getters.getBackgroudImageStyle
        }
    },
    watch: {
    },
    methods: {
        clear(){
            this.$refs.hTreeTable.clear()
        },
        //添加同级
			addMenu() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选同级单位!")
					return
                }
                if(isempty(this.nowMenu.parentId)) {
					this.$dialogMethod.showMessage("该单位为基础单位，不能添加同级单位!")
					return
				}
				var dialog = this.$dialogMethod.createDialog(unitManageDialog)
                dialog.open( undefined, item => {
                    this.$api.unitApi.saveUnit(undefined, item.type, this.nowMenu.parentId, item.unitCode, item.name, item.fullName, item.address, item.leader, item.phoneNum, item.memo, item.sort, item.capacity, item.inletWire, item.location, item.joinTime, item.expirationTime, item.roomCount, item.transformerCount, item.loadCapacity, respon => {
                    this.nowMenu = undefined
                    this.$store.unitStore.commit('getUnitTree')
                    this.$dialogMethod.showMessage('保存成功')
                    this.clear()
                    }, err => {
                        this.$dialogMethod.showMessage('保存失败')
                    })
				})
			},
			//添加子级
			addMenuChild() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选中父级单位!")
					return
                }
                var dialog = this.$dialogMethod.createDialog(unitManageDialog)
                dialog.open( undefined, item => {
                    this.$api.unitApi.saveUnit(undefined, item.type, this.nowMenu.id, item.unitCode, item.name, item.fullName, item.address, item.leader, item.phoneNum, item.memo, item.sort, item.capacity, item.inletWire, item.location, item.joinTime, item.expirationTime, item.roomCount, item.transformerCount, item.loadCapacity, respon => {
                    this.nowMenu = undefined
                    this.$store.unitStore.commit('getUnitTree')
                    this.$dialogMethod.showMessage('保存成功')
                    this.clear()
                    }, err => {
                        this.$dialogMethod.showMessage('保存失败')
                    })
				})
			},
			//修改
			editMenu() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选中要编辑的web单位!")
					return
				}
                var dialog = this.$dialogMethod.createDialog(unitManageDialog)
                dialog.open(this.nowMenu, item => {
                    this.$api.unitApi.saveUnit( item.id, item.type, item.parentId, item.unitCode, item.name, item.fullName, item.address, item.leader, item.phoneNum, item.memo, item.sort, item.capacity, item.inletWire, item.location, item.joinTime, item.expirationTime, item.roomCount, item.transformerCount, item.loadCapacity, respon => {
                    this.nowMenu = undefined
                    this.$store.unitStore.commit('getUnitTree')
                    this.$dialogMethod.showMessage('保存成功')
                    this.clear()
                    }, err => {
                        this.$dialogMethod.showMessage('保存失败')
                    })
                })
			},
			//删除
			deleteMenu() {
				if(this.nowMenu == undefined) {
					this.$dialogMethod.showMessage("请先选中要删除的单位!")
					return
                }
				var id = this.nowMenu.id //当前选中web单位的id
				var name = this.nowMenu.name //当前选中web单位的名称
				this.$dialogMethod.openAgreeDialog("删除web单位", "是否删除 " + name, () => {
					//删除接口
					this.$api.unitApi.delUnit(id, respon => {
                        this.$dialogMethod.showMessage(respon)
                        this.nowMenu = undefined
                        this.$store.unitStore.commit('getUnitTree')
                        this.clear()
					}, respon => {
                        this.$dialogMethod.showMessage(respon)
						//err(respon)
					})
				})
			},
			refresh() {
                this.$store.unitStore.commit('getUnitTree')
            },
            
        changeActive(val){
            this.nowMenu = val
        },
        handlerExpand(m) {
            m.isExpand = !m.isExpand
        },
    }
}
</script>

<style scoped>
.unitManageBody {
    width: 100%;
    height: 100%;
}

.unitMangeTitle {
    width: 95%;
    margin: 0 auto;
    height: 5%;
    margin-top: 0.1rem;
    display: flex;
    align-items: center;
}
.unitMangeContent_table {
    width: 100%;
	height: 80%;
	padding-top: 1.5%;
	box-sizing: border-box;
}
.unitMangeContent_header_right{
	font-size: 0.16rem;
	color: rgb(115,115,115);
}
.unitMangeContent_header{
	display: flex;
	align-items: center;
	padding-top: 5%;
}
.unitMangeContent_box{
	width: 95%;
	height: 100%;
	margin: auto;
}
.unitMangeContent_header_left{
	width: 0.12rem;
	height: 0.28rem;
	margin-right: 0.14rem;
	background: rgb(20, 155, 233);
}
.unitMangeContent {
    width: 95%;
    margin: 0 auto;
    height: 90%;
    margin-top: 0.1rem;
}
.unitMangeContentTitle {
    padding-top: 0.5rem;
    width: 95%;
    margin: 0 auto;
    display: flex;
    align-items: center;
}
.unitMangeContentTitle span {
    color: #878787;
    padding-left: 0.15rem;
}
.unitMangeContent table {
    width: 95%;
    margin: 0 auto;
    margin-top: 0.1rem;
    background-color: #dcecf2;
}
.unitMangeContent table tr {
    width: 100%;
}
.unitMangeContent table tr td {
    padding: 0.1rem 0rem;
    color: #139ae6;
}
.unitMangeContent table tr td:nth-child(1) {
    width: 17.5%;
    padding-left: 0.3rem;
}
.unitMangeContent table tr td:nth-child(2) {
    width: 12%;
    padding-left: 0.1rem;
}
.unitMangeContent table tr td:nth-child(3) {
    width: 15%;
    padding-left: 0.1rem;
}
.unitMangeContent table tr td:nth-child(4) {
    width: 17%;
    padding-left: 0;
}
.unitMangeContent table tr td:nth-child(5) {
    width: 16.6%;
    padding-left: 0;
}
.unitMangeContent table tr td:nth-child(6) {
    width: 25%;
    padding-left: 0;
}
</style>
